"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _default = exports["default"] = {
  generateSymmetricallyEncryptedPayload: function generateSymmetricallyEncryptedPayload(service, data, uuid, origin) {
    return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var urlEncodedData, fernetInstance, encryptedData;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            // Stringify and encode the data
            urlEncodedData = JSON.stringify(data); // Create a Fernet instance with the symmetric key
            _context.next = 3;
            return Fernet.create(service.symmetricKey);
          case 3:
            fernetInstance = _context.sent;
            _context.next = 6;
            return fernetInstance.encrypt(urlEncodedData);
          case 6:
            encryptedData = _context.sent;
            return _context.abrupt("return", JSON.stringify({
              uuid: uuid,
              action: "".concat(service.serviceIdentification, ".ServiceCall"),
              data: encryptedData,
              // Already Base64-encoded in the Fernet token
              origin: origin,
              requestUuid: ""
            }));
          case 8:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  decryptSymmetrically: function decryptSymmetrically(service, payload) {
    return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2() {
      var binaryStr, utf8Bytes, payloadToDecode, fernetInstance, decryptedMessage;
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (service.symmetricKey) {
              _context2.next = 2;
              break;
            }
            throw new Error("Symmetric key is missing");
          case 2:
            // Decode Base64 to a binary string
            binaryStr = window.atob(payload); // Convert binary string to a Uint8Array
            utf8Bytes = Uint8Array.from(binaryStr, function (_char) {
              return _char.charCodeAt(0);
            }); // Convert Uint8Array back to a string (UTF-8)
            payloadToDecode = new TextDecoder().decode(utf8Bytes);
            _context2.next = 7;
            return Fernet.create(service.symmetricKey);
          case 7:
            fernetInstance = _context2.sent;
            _context2.next = 10;
            return fernetInstance.decrypt(payloadToDecode);
          case 10:
            decryptedMessage = _context2.sent;
            return _context2.abrupt("return", decryptedMessage);
          case 12:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }))();
  },
  decryptAsymmetric: function decryptAsymmetric(privateKey, data) {
    return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3() {
      return _regenerator["default"].wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return crypto.subtle.decrypt({
              name: "RSA-OAEP",
              hash: {
                name: "SHA-256"
              }
            }, privateKey, data);
          case 2:
            return _context3.abrupt("return", _context3.sent);
          case 3:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }))();
  }
}; // Below is the Fernet class used for encryption and decryption
var Fernet = /*#__PURE__*/function () {
  function Fernet(signingKey, encryptionKey) {
    (0, _classCallCheck2["default"])(this, Fernet);
    this.signingKey = signingKey;
    this.encryptionKey = encryptionKey;
  }
  return (0, _createClass2["default"])(Fernet, [{
    key: "encrypt",
    value: function () {
      var _encrypt = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee4(plainText) {
        var plainTextBuffer, ivBuffer, encryptedMessage, version, timeBuffer, view, currentTime, unixEpochTime, timestamp, iv, ciphertext, unsigned_token, hmac, signed_token, tokenChars, data, utf8Bytes, binaryStr;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              plainTextBuffer = new TextEncoder().encode(plainText);
              ivBuffer = new Uint8Array(16); // Generate random IV
              crypto.getRandomValues(ivBuffer);
              _context4.next = 5;
              return crypto.subtle.encrypt({
                name: "AES-CBC",
                iv: ivBuffer
              }, this.encryptionKey, plainTextBuffer);
            case 5:
              encryptedMessage = _context4.sent;
              version = new Uint8Array([0x80]);
              timeBuffer = new ArrayBuffer(8);
              view = new DataView(timeBuffer);
              currentTime = Date.now();
              unixEpochTime = Math.round(currentTime / 1000);
              view.setBigUint64(0, BigInt(unixEpochTime), false);
              timestamp = new Uint8Array(timeBuffer);
              iv = new Uint8Array(ivBuffer);
              ciphertext = new Uint8Array(encryptedMessage);
              unsigned_token = new Uint8Array([].concat((0, _toConsumableArray2["default"])(version), (0, _toConsumableArray2["default"])(timestamp), (0, _toConsumableArray2["default"])(iv), (0, _toConsumableArray2["default"])(ciphertext)));
              _context4.t0 = Uint8Array;
              _context4.next = 19;
              return crypto.subtle.sign({
                name: "HMAC",
                hash: "SHA-256"
              }, this.signingKey, unsigned_token);
            case 19:
              _context4.t1 = _context4.sent;
              hmac = new _context4.t0(_context4.t1);
              signed_token = new Uint8Array([].concat((0, _toConsumableArray2["default"])(version), (0, _toConsumableArray2["default"])(timestamp), (0, _toConsumableArray2["default"])(iv), (0, _toConsumableArray2["default"])(ciphertext), (0, _toConsumableArray2["default"])(hmac)));
              tokenChars = [];
              signed_token.forEach(function (_byte) {
                tokenChars.push(String.fromCharCode(_byte));
              });
              data = window.btoa(tokenChars.join("")).replace(/\+/g, "-").replace(/\//g, "_");
              utf8Bytes = new TextEncoder().encode(data);
              binaryStr = String.fromCharCode.apply(String, (0, _toConsumableArray2["default"])(utf8Bytes));
              return _context4.abrupt("return", window.btoa(binaryStr));
            case 28:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function encrypt(_x) {
        return _encrypt.apply(this, arguments);
      }
      return encrypt;
    }()
  }, {
    key: "decrypt",
    value: function () {
      var _decrypt = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee5(token_b64) {
        var tokenBuffer, version, timestamp, iv, ciphertext, hmac, decrypted, decryptedMessage, unsigned_token, verification;
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              tokenBuffer = Uint8Array.from(window.atob(token_b64.replace(/_/g, '/').replace(/-/g, '+')), function (c) {
                return c.charCodeAt(0);
              });
              version = tokenBuffer.slice(0, 1);
              timestamp = tokenBuffer.slice(1, 9);
              iv = tokenBuffer.slice(9, 25);
              ciphertext = tokenBuffer.slice(25, -32);
              hmac = tokenBuffer.slice(-32);
              _context5.next = 8;
              return crypto.subtle.decrypt({
                name: "AES-CBC",
                iv: iv
              }, this.encryptionKey, ciphertext);
            case 8:
              decrypted = _context5.sent;
              decryptedMessage = new TextDecoder().decode(decrypted);
              unsigned_token = new Uint8Array([].concat((0, _toConsumableArray2["default"])(version), (0, _toConsumableArray2["default"])(timestamp), (0, _toConsumableArray2["default"])(iv), (0, _toConsumableArray2["default"])(ciphertext)));
              _context5.next = 13;
              return crypto.subtle.verify({
                name: "HMAC",
                hash: "SHA-256"
              }, this.signingKey, hmac, unsigned_token);
            case 13:
              verification = _context5.sent;
              if (verification) {
                _context5.next = 16;
                break;
              }
              throw new Error("Invalid token or token has been tampered with");
            case 16:
              return _context5.abrupt("return", decryptedMessage);
            case 17:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function decrypt(_x2) {
        return _decrypt.apply(this, arguments);
      }
      return decrypt;
    }()
  }], [{
    key: "initializeKeys",
    value: function () {
      var _initializeKeys = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee6(secretKeyBuffer) {
        var signingKeyBuffer, encryptionKeyBuffer, signingKey, encryptionKey;
        return _regenerator["default"].wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              signingKeyBuffer = secretKeyBuffer.slice(0, 16);
              encryptionKeyBuffer = secretKeyBuffer.slice(16);
              _context6.next = 4;
              return crypto.subtle.importKey("raw", signingKeyBuffer, {
                name: "HMAC",
                hash: "SHA-256"
              }, false, ["verify", "sign"]);
            case 4:
              signingKey = _context6.sent;
              _context6.next = 7;
              return crypto.subtle.importKey("raw", encryptionKeyBuffer, "AES-CBC", false, ["encrypt", "decrypt"]);
            case 7:
              encryptionKey = _context6.sent;
              return _context6.abrupt("return", {
                signingKey: signingKey,
                encryptionKey: encryptionKey
              });
            case 9:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }));
      function initializeKeys(_x3) {
        return _initializeKeys.apply(this, arguments);
      }
      return initializeKeys;
    }()
  }, {
    key: "create",
    value: function () {
      var _create = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee7() {
        var secretKey_b64,
          secretKeyBuffer,
          keys,
          _args7 = arguments;
        return _regenerator["default"].wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              secretKey_b64 = _args7.length > 0 && _args7[0] !== undefined ? _args7[0] : null;
              secretKeyBuffer = new Uint8Array(32);
              if (secretKey_b64 !== null) {
                // Decode the URL-safe base64-encoded secret key
                secretKeyBuffer = Uint8Array.from(window.atob(secretKey_b64.replace(/_/g, '/').replace(/-/g, '+')), function (c) {
                  return c.charCodeAt(0);
                });
              } else {
                // Generate a new secret key
                crypto.getRandomValues(secretKeyBuffer);
              }
              _context7.next = 5;
              return Fernet.initializeKeys(secretKeyBuffer);
            case 5:
              keys = _context7.sent;
              return _context7.abrupt("return", new Fernet(keys.signingKey, keys.encryptionKey));
            case 7:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }));
      function create() {
        return _create.apply(this, arguments);
      }
      return create;
    }()
  }]);
}();